import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { formatDateForBackend } from '../../../helpers/util';
import { Order, OrderDTO, OrdersFilters } from './../../models/order';
import { LaravelRidersService } from './laravel-riders.service';

@Injectable({
  providedIn: "root"
})
export class LaravelOrderService {
  constructor(private httpClient: HttpClient, private ridersService: LaravelRidersService) { }

  private get ROUTES() {
    return {
      show: environment.baseUrl + "/api/orders",
      list: environment.baseUrl + "/api/orders",
      store: environment.baseUrl + "/api/orders",
      update: environment.baseUrl + "/api/orders",
      delete: environment.baseUrl + "/api/orders",
      ship: environment.baseUrl + "/api/orders/ship",
      delivered: environment.baseUrl + "/api/orders/deliver",
      confirm: environment.baseUrl + "/api/confirm",
      inProgress: environment.baseUrl + "/api/in-progress",
      markAsDelivered: environment.baseUrl + "/api/markAsDelivered",
      assignRiderToOrder: (orderId: number) => `${environment.baseUrl}/api/orders/${orderId}/assign-rider`,
    };
  }

  public getById(id: number, include?: string[]): Observable<any> {
    let params = {};
    if (include) params["include[]"] = include;
    return this.httpClient.get(`${this.ROUTES.show}/${id}`, {
      params: new HttpParams({
        fromObject: params
      })
    });
  }

  public list(
    page: number,
    per_page: number,
    order: string,
    direction: string,
    filters: OrdersFilters,
    zoneIds?: Array<number>,
    statuses?: Array<number>,
    date?: string,
    customer_id?: number,
    deliveryman_id?: number,
    include_pick?: boolean,
    include_delivery?: boolean,
    with_sweets?: boolean,
    include_archived?: boolean,
    include?: string[],
    
  ): Observable<any> {
    let params = {};
    if (page) params["page"] = "" + page;
    if (per_page) params["per_page"] = "" + per_page;
    if (order) params["order"] = "" + order;
    if (direction) params["direction"] = "" + direction;

    if (filters) {
      if (filters.tenant_id) params["tenant_id"] = "" + filters.tenant_id;            
    }


    if (include) params["include[]"] = include;

    if (!include_pick) params["exclude_pick"] = true;
    if (!include_delivery) params["exclude_delivery"] = true;

    if (customer_id) params["customer_id"] = customer_id;
    if (deliveryman_id) params["deliveryman_id"] = deliveryman_id;
    if (with_sweets) params["with_sweets"] = true;
    if (include_archived) params["include_archived"] = true;

    if (zoneIds) {
      if (zoneIds.length > 0) params["zones[]"] = zoneIds;
    }
    if (statuses) {
      if (statuses.length > 0) params["statuses[]"] = statuses;
    }
    if (date) params["date"] = date;
   

    return this.httpClient.get(this.ROUTES.list, {
      params: new HttpParams({ fromObject: params })
    });
  }

  public create(order: OrderDTO): Observable<any> {
    return this.httpClient.post(this.ROUTES.store, {
      order: order
    });
  }

  public update(order: OrderDTO): Observable<any> {
    return this.httpClient.put(`${this.ROUTES.update}/${order.id}`, {
      order: order
    });
  }

  public upsert(order: OrderDTO): Observable<OrderDTO> {
    if(order.id){
      return this.httpClient.put<OrderDTO>(`${this.ROUTES.store}/${order.id}`, order);
    } else {
      return this.httpClient.post<OrderDTO>(`${this.ROUTES.store}`, order);
    }
  }

  public delete(id) {
    return this.httpClient.delete(`${this.ROUTES.delete}/${id}`);
  }

  public ship(deliveryManID: number, orderID: number, shippedAt: Date) {
    return this.httpClient.post(this.ROUTES.ship, {
      deliveryman_id: deliveryManID,
      order_id: orderID,
      shipped_at: formatDateForBackend(shippedAt, true)
    });
  }

  public markDelivered(orderID: number, deliveredAt: Date) {
      return this.httpClient.post(this.ridersService.ROUTES.setOrderAsDelivered(orderID), {
        order_id: orderID,
        delivered_at: formatDateForBackend(deliveredAt, true)
      });
    }

  public confirm(id: number) {
    return this.httpClient.patch(`${this.ROUTES.confirm}/${id}`, {});
  }

  public inProgress(id: number) {
    return this.httpClient.patch(`${this.ROUTES.inProgress}/${id}`, {});
  }

  public markAsDelivered(id: number) {
    return this.httpClient.patch(`${this.ROUTES.markAsDelivered}/${id}`, {});
  }

  public assignRiderToOrder(orderId: number, rider_id: number): Observable<any> {
    return this.httpClient.patch(this.ROUTES.assignRiderToOrder(orderId), { rider_id });
  }
}
